export default __webpack_public_path__ + "static/media/mon_256.5fce1e60.png";